import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/custom/button";
import { PiUpload } from "react-icons/pi";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { usePermissions } from "@/hooks/use-permissions";
import { UploadClustersDialog } from "./-upload-clusters-dialog";

export const UploadClusters = () => {
  const { t } = useTranslation();
  const { permissions } = usePermissions();
  const [open, setOpen] = React.useState(false);

  // POST /clusters/upload requires clusters.create
  if (!permissions.clusters.create) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="flex gap-1 justify-around">
          <PiUpload className="w-4 h-4" />
          {t("uploadAFile")}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <VisuallyHidden>
          <DialogTitle>{t("Upload Clusters CSV")}</DialogTitle>
          <DialogDescription>
            {t("Upload your clusters CSV file")}
          </DialogDescription>
        </VisuallyHidden>
        {open && <UploadClustersDialog onClose={() => setOpen(false)} />}
      </DialogContent>
    </Dialog>
  );
};
